import { render, staticRenderFns } from "./weight.vue?vue&type=template&id=798a920c&scoped=true"
import script from "./weight.vue?vue&type=script&lang=js"
export * from "./weight.vue?vue&type=script&lang=js"
import style0 from "./weight.vue?vue&type=style&index=0&id=798a920c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798a920c",
  null
  
)

export default component.exports